import {AlignType} from "rc-table/lib/interface"

export const center = 'center' as AlignType
